export default "__VITE_ASSET__Cgq70rSY__"